import { Button } from 'react-bootstrap';
import { Localization } from "@viamap/viamap2-common";
import { CatchmentInterface } from '../managers/CatchmentInterface';
import { CatchmentStateContext } from 'src/states/CatchmentState';
import { VLine, SidePanelScrolling } from './MitGlassComponents';
import { useContext } from 'react';
import { MIBIcon } from 'src/componentsUtils/MIBIcon';


export type CatchmentSelectionState = string | null;

type Props = {
  showWindow: boolean;
  isCollapsed: boolean;
  showHideButton: boolean;
  horizontal?: boolean;
  hideCatchments: () => void;
  showDownloadButton: boolean;
  showRushHourSelector: boolean;
  showCombinedBikeAndTransit: boolean;
  onChange: (modeOfTransport: string, rushHourMode: boolean) => void
  onDownloadCatchments?: () => void;
  onSaveCatchments?: () => void;
  onToggleShowItemCounts?: () => void;
};

export const CatchmentSelector = (props: Props) => {
  const { state: catchmentState } = useContext(CatchmentStateContext);

  function onClickApply() {
  }
  function onClickHideCatchment() {
    props.hideCatchments?.();
  }

  function onClickDownloadCatchment() {
    props.onDownloadCatchments?.();
  }

  function onClickSigma() {
    props.onToggleShowItemCounts?.();
  }

  function onClickCreateLayerForCatchment() {
    props.onSaveCatchments?.();
  }

  if (props.showWindow) {
    let renderToggleButtons = props.isCollapsed
      ? null
      : CatchmentInterface.transportModes.filter((key) => {
        // Only show 'transit of bike' icon if enabled.
        return props.showCombinedBikeAndTransit || key.type !== 'transitorbike';
      }).map((key) => {
        let label = Localization.getText("ModeOfTransport:" + key.type);
        let imageClassSelected =
          catchmentState.selectedModeOfTransport === key.type ? " active" : "";
        return (
          <div
            key={key.type}
            title={label}
            onClick={() => {
              props.onChange?.(key.type, catchmentState.rushHourMode);
            }}
            className={"ExtendedMenuButton " + imageClassSelected}
          >
            <MIBIcon icon={key.type} />
          </div>
        );
      });
    let label2 = Localization.getText("Click to hide travel times");
    let hideButton = props.showHideButton ? (
      <>
        <div className="ExtendedMenuButton"
          onClick={() => onClickHideCatchment()}
          title={label2}
        >
          <MIBIcon icon="dismiss" />
        </div>
        <VLine />
      </>
    ) : null;
    let saveAsNewLayersButton = props.onSaveCatchments ? (
      <>
        <VLine />
        <button
          onClick={() => onClickCreateLayerForCatchment()}
          title={Localization.getText("Click to save travel times as new layer")}
          className="ExtendedMenuButton">
          <MIBIcon icon="addToMap" />
        </button>
      </>
    ) : null;
    let sigmaButton = props.onToggleShowItemCounts ? (
      <>
        <VLine />
        <button
          onClick={() => onClickSigma()}
          title={Localization.getText("Click to toggle area item counts")}
          className={"ExtendedMenuButton" + (catchmentState.showSpatialItemsCounts ? " active" : "")}>
          <MIBIcon icon="tæl" />
        </button>
      </ >
    ) : null;
    let downloadButton = props.showDownloadButton ? (
      <>
        <VLine />
        <button className="ExtendedMenuButton"
          onClick={() => onClickDownloadCatchment()}
          title={Localization.getText("Click to download travel times")}
        >
          <MIBIcon icon="download" />
        </button>
      </>
    ) : null;
    let isActive = catchmentState.selectedModeOfTransport === "car";
    let imageClassSelectedRh =
      isActive && catchmentState.rushHourMode ? " active" : "";
    let imageClassInactiveRh = isActive ? "" : " inactive";
    let rushHourModeCheckBox = props.showRushHourSelector ? (
      <>
        <VLine />
        <button className={"ExtendedMenuButton" +
          imageClassSelectedRh +
          imageClassInactiveRh}
          title={Localization.getText("Click to toggle Rush Hour mode")}
          onClick={() => {
            if (isActive) {
              props.onChange?.(catchmentState.selectedModeOfTransport!, !catchmentState.rushHourMode);
            }
          }}
        >
          <MIBIcon icon="rushHour" />
        </button>
      </>
    ) : null;
    return (
      <>
        <div
          className="ExtendedSideBar CatchmentSelector " style={{ top: "calc(1*var(--TopSpace))" }}
        >
          <div className='LeftInnerShadow'></div>
          <SidePanelScrolling >
            {hideButton}
            {renderToggleButtons}
            {rushHourModeCheckBox}
            {sigmaButton}
            {saveAsNewLayersButton}
            {downloadButton}
            <Button
              style={{
                display: "none",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onClick={() => onClickApply()}
            >
              Apply
            </Button>
          </SidePanelScrolling>
        </div>
      </>
    );
  } else {
    return null;
  }
}